<template>
  <div class="postavitev-info">
    <div>
      <div class="info-okvir">
        <div class="postavitev-info-icone">
          <i class="fa fa-info-circle"></i>
        </div>
        <div class="postavitev-info-tekst">
          <p class="modra-barva-info">
            <b> Hvala za naročilo! </b>
          </p>
          <p class="modra-barva-info">
            Vaše naročilo je bilo uspešno prejeto in je trenutno v obdelavi.
            V tem času naknadne spremembe naročene storitve preko portala MOJ T-2 žal niso mogoče.
            Predviden čas obdelave je teden dni od naročila.
            Za dodatne informacije ali pomoč smo vam na voljo na telefonski številki 064 064 064.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderExistsInfo'
}
</script>

<style scoped>
.postavitev-info {
  padding-top: 35px;
}

.postavitev-info-icone {
  padding-right: 30px;
}

.info-okvir {
  width: 660px;
  display: flex;
}

@media only screen and (max-width: 1186px) {
  .info-okvir {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/OrderExistsInfo.vue